import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { XUser } from '@core/utils';

interface ReduxState {
  user: {
    data: {
      role: number;
    };
  };
}

export const useUserRoleAllowed = (rolesAllowed: number | number[]) => {
  const { role } = useSelector((state: ReduxState) => state.user.data);

  const isUserAllowed = useMemo(
    () => XUser.isUserCombinedRoleAllowed(rolesAllowed, role),
    [rolesAllowed, role]
  );

  return isUserAllowed;
};
